import {LANGUAGE_MODAL} from "../constants";

export const openLanguageModal = (open) => {
  return {
    type: LANGUAGE_MODAL,
    open
  }
};